module.exports = __webpack_public_path__ + "assets/img/newimglr.dd9194c0.png";